import { UserListItemDto } from '../config/userConfig'
import useGlobalContext from './useGlobalContext'
import { useMemo } from 'react'

export type UsersProps = {
    loaded: boolean
    users: UserListItemDto[]
    getUserById: (id: string) => UserListItemDto
    getUserByEmail: (email: string) => UserListItemDto
}

export default function useUsers(): UsersProps {
    const { loaded, entities } = useGlobalContext('users')

    const users = useMemo(() => entities || [], [loaded, entities])
    const getUserById: UsersProps['getUserById'] = (id: string): UserListItemDto => entities?.find(user => user.id === id)
    const getUserByEmail: UsersProps['getUserByEmail'] = (email: string): UserListItemDto =>
        entities?.find(user => user.email?.toLowerCase() === email?.toLowerCase())

    return { loaded, users, getUserById, getUserByEmail }
}
